import { lookupboxCadastral } from "../poiagg";

function enrichLookupResponse(data) {
	for (let index = 0; index < data.entity.length; index++) {
		data.entity[index].geom.style = {
			color: "#ffffff",
			opacity: 0,
			outlineOpacity: data.entity[index].source === "plot" ? 0 : 1,
			outlineWidth: 2,
			outlineColor: "#ffffff",
		};

		if (data.entity[index].source === "plot" && !data.entity[index].geomFake) {
			data.entity[index].geom.type = "path";
		}

		data.entity[index].geom.minDist = 0;
	}

	data.poi = data.entity;
	delete data.entity;
}

export default class CadastralLookupbox {
	_request: any;

	constructor() {
		this._request = null;
	}

	lookupbox() {
		if (this._request) {
			this._request.abort();
			this._request = null;
		}

		const lookupboxData = lookupboxCadastral();

		this._request = lookupboxData.request;

		return new Promise((resolve, reject) => {
			lookupboxData.promise.then(data => {
				enrichLookupResponse(data);
				resolve(data);
			}, error => reject(error));
		});
	}
}
